
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.4 11.2a5.6 5.6 0 015.6 5.6v14.933a5.6 5.6 0 01-5.6 5.6H5.6a5.6 5.6 0 01-5.6-5.6V16.8a5.6 5.6 0 015.6-5.6V8.4a8.4 8.4 0 0116.8 0v2.8zM5.6 13.067A3.733 3.733 0 001.867 16.8v14.933A3.733 3.733 0 005.6 35.467h16.8a3.734 3.734 0 003.733-3.734V16.8a3.734 3.734 0 00-3.733-3.733H5.6zM20.533 11.2V8.4a6.533 6.533 0 10-13.066 0v2.8h13.066zM14 22.4a2.8 2.8 0 100 5.6 2.8 2.8 0 000-5.6zm0-1.867a4.666 4.666 0 110 9.333 4.666 4.666 0 010-9.333z","fill":"#000","fill-opacity":".886"}})])
          )
        }
      }
    